/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DataChartBarsXyVUpIcon16Light } from './DataChartBarsXyVUpIcon16Light';
import { DataChartBarsXyVUpIcon16Regular } from './DataChartBarsXyVUpIcon16Regular';
import { DataChartBarsXyVUpIcon16Solid } from './DataChartBarsXyVUpIcon16Solid';
import { DataChartBarsXyVUpIcon20Light } from './DataChartBarsXyVUpIcon20Light';
import { DataChartBarsXyVUpIcon20Regular } from './DataChartBarsXyVUpIcon20Regular';
import { DataChartBarsXyVUpIcon20Solid } from './DataChartBarsXyVUpIcon20Solid';
import { DataChartBarsXyVUpIcon24Regular } from './DataChartBarsXyVUpIcon24Regular';
import { DataChartBarsXyVUpIcon24Solid } from './DataChartBarsXyVUpIcon24Solid';
import { DataChartBarsXyVUpIcon32Regular } from './DataChartBarsXyVUpIcon32Regular';
import { DataChartBarsXyVUpIcon64Regular } from './DataChartBarsXyVUpIcon64Regular';
var sizes = {
    16: {
        light: DataChartBarsXyVUpIcon16Light,
        regular: DataChartBarsXyVUpIcon16Regular,
        solid: DataChartBarsXyVUpIcon16Solid,
    },
    20: {
        light: DataChartBarsXyVUpIcon20Light,
        regular: DataChartBarsXyVUpIcon20Regular,
        solid: DataChartBarsXyVUpIcon20Solid,
    },
    24: {
        regular: DataChartBarsXyVUpIcon24Regular,
        solid: DataChartBarsXyVUpIcon24Solid,
    },
    32: {
        regular: DataChartBarsXyVUpIcon32Regular,
    },
    64: {
        regular: DataChartBarsXyVUpIcon64Regular,
    },
};
export var DataChartBarsXyVUpIcon = forwardRef('DataChartBarsXyVUpIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
